// pages/GalleryLanding.js
import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ to, title, description, imageSrc }) => {
  return (
    <Link 
      to={to}
      className="relative aspect-square w-full overflow-hidden group"
    >
      {/* Image */}
      <img 
        src={imageSrc || "/api/placeholder/800/800"} 
        alt={title}
        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
      />
      
      {/* Overlay that appears on hover */}
      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center p-6">
        <h3 className="text-2xl font-bold text-white mb-2">{title}</h3>
        <p className="text-white/90">{description}</p>
      </div>
    </Link>
  );
};

const GalleryLanding = () => {
  const categories = [
    {
      to: "/gallery/2d",
      title: "2D Works",
      description: "Explore paintings, drawings, and mixed media pieces that push traditional boundaries.",
      imageSrc: "/preview_2D.jpg" // Replace with actual image path
    },
    {
      to: "/gallery/video",
      title: "Video Works",
      description: "Experience dynamic video installations and time-based media projects.",
      imageSrc: "/preview_video.PNG" // Replace with actual image path
    },
    {
      to: "/gallery/3d",
      title: "3D Works",
      description: "Discover sculptures and three-dimensional installations that challenge space.",
      imageSrc: "/preview_3D.jpg" // Replace with actual image path
    }
  ];

  return (
    <div className="min-h-screen pt-8 px-4 lg:pt-12 lg:px-6">
      

      {/* Categories Grid */}
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6">
          {categories.map((category, index) => (
            <CategoryCard key={index} {...category} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryLanding;